import React from "react";
import { useNavigate } from "react-router-dom";
import BlitzLogo from "../../assets/images/blitz_logo.svg";
import { useWhitelisting } from "../../utils/hooks/useWhitelisting";
import { track } from "../../analytics";
import styles from "./style.module.css";

const WHATSAPP_URL = "https://api.whatsapp.com/send?phone=919606097301";

// White header with the seller logo, from the Claude Design pages
// ("Tracking Result", "Manage Order"). Whitelisted brands show their logo; others Blitz.
// forceLogo: show the logo even while brand info is loading (e.g. after a failed load).
// chat: show the "Chat with us" WhatsApp pill opposite the logo (same pill as the homepage header).
const PageHeader = ({ forceLogo = false, chat = false }) => {
  const navigate = useNavigate();
  const { isWhitelisted, trackingPageLogo, loading } = useWhitelisting();
  const logo = isWhitelisted ? trackingPageLogo : BlitzLogo;
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <button type="button" className={styles.logoBtn} onClick={() => navigate("/")} aria-label="Home">
          {(forceLogo || !loading) && (
            <img
              src={logo || BlitzLogo}
              alt="Logo"
              onError={(e) => {
                if (e.currentTarget.src !== BlitzLogo) e.currentTarget.src = BlitzLogo;
              }}
            />
          )}
        </button>
        {chat && (
          <div className={styles.actions}>
            <span className={styles.help}>Need help?</span>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className={styles.chat}
              onClick={() => track("tp_cta_click", { cta: "chat_support", placement: "header" })}
            >
              <span className={styles.chatDot} />
              Chat with us
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default PageHeader;
